import Swal from "sweetalert2";
import xlsx from "json-as-xlsx";
import moment from "moment-timezone";
import { save_role } from "../controllers/helps.controller";
import { information } from "../information.js";

export const checkAuth = () => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch(
    localStorage.getItem("endpoint-redeem") +
      "/checkAuth?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      if (result.statusCode === 403 || result.statusCode === 498) {
        alert(
          "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại để tiếp tục sử dụng."
        );
        localStorage.clear();
        window.location.replace("/login");
      }
      if (result.status_code === 403) {
        alert("Bạn không có quyền thao tác, vui lòng liên hệ Admin");
        localStorage.clear();
        window.location.replace("/login");
      }
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire("Lỗi!", "Mất kết nối đến máy chủ", "warning");
    });
};
export const generateCode = (data) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");

  data.createdBy = localStorage.getItem("username-redeem");
  console.log(data);
  const raw = JSON.stringify(data);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: raw,
  };
  fetch(
    localStorage.getItem("endpoint-redeem") +
      "/generate-code?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      document.getElementById("download-btn").setAttribute("click-id", "false");
      if (result?.code === 9009) {
        return Swal.fire({
          title: "Random CODE trùng",
          icon: "error",
          html: "<p></p> <p>-> Thêm `Độ dài code`</p><p>-> `Xóa code` cũ</p>",
        });
      }

      let data = [
        {
          sheet: "code_sheet",
          columns: [
            { label: "Mã phát hành", value: "releaseCode" },
            { label: "Mã khuyến mãi", value: "promo_id" },
            { label: "Loại code", value: "type_code" },
            { label: "Code", value: "promo_code" },
            { label: "Điểm thưởng", value: "point" },
            { label: "Vòng cược", value: "round" },
            { label: "Thời gian đầu", value: "start_time" },
            { label: "Thời gian cuối", value: "end_time" },
            { label: "Nạp tiền", value: "deposite" },
            { label: "Rút tiền", value: "withdraw" },
            { label: "Check IPFP", value: "checkIPFP" },
            { label: "Gửi thư", value: "internalMess" },
            { label: "Người sử dụng", value: "user_used" },
            { label: "IP", value: "ip" },
            { label: "FP", value: "fp" },
            { label: "Thời gian sử dụng", value: "used_time" },
          ],
          content: [],
        },
      ];

      result?.detail.forEach((el) => {
        data[0].content.push({
          releaseCode: el.releaseCode,
          promo_id: el.promo_id,
          promo_code: el.promo_code,
          type_code:
            el?.type_code === "one_only"
              ? "Nhận 1 lần"
              : el?.type_code === "one_per_day"
              ? "Nhận 1 lần/ngày"
              : el?.type_code === "one_per_3day"
              ? "nhận 1 code/3ngày"
              : el?.type_code === "one_per_week"
              ? "Nhận 1 lần/tuần"
              : el?.type_code === "one_per_month"
              ? "Nhận 1 lần/tháng"
              : el?.type_code === "no_limit"
              ? "Không giới hạn"
              : "Không xác định",
          point: el.point,
          round: el.round,
          checkIPFP: el.checkIPFP === "check" ? "Có" : "",
          internalMess: el.internalMess === "send" ? "Có" : "",
          user_used: el.user_used,
          ip: el.ip,
          fp: el.fp,
          used_time: el.used_time
            ? moment(el.used_time)
                .tz("Asia/Ho_Chi_Minh")
                .format("YYYY/MM/DD H:mm:ss")
            : "",
          deposite:
            el.deposite === "all"
              ? "Tất cả"
              : el.deposite === "more_then"
              ? "Nạp >=" +
                el.depositeCount +
                " (lần), >=" +
                el.depositeTotal +
                " (K)"
              : el.deposite === "less_then"
              ? "Nạp <" +
                el.depositeCount +
                " (lần), <" +
                el.depositeTotal +
                " (K)"
              : "",
          withdraw:
            el.withdraw === "all"
              ? "Tất cả"
              : el.withdraw === "more_then"
              ? "Rút >=" +
                el.withdrawCount +
                " (lần), >=" +
                el.withdrawTotal +
                " (K)"
              : el.withdraw === "less_then"
              ? "Rút <" +
                el.withdrawCount +
                " (lần), <" +
                el.withdrawTotal +
                " (K)"
              : "",
          start_time: moment(el.startOf_time)
            .tz("Asia/Ho_Chi_Minh")
            .format("YYYY/MM/DD H:mm:ss"),
          end_time: moment(el.endOf_time)
            .tz("Asia/Ho_Chi_Minh")
            .format("YYYY/MM/DD H:mm:ss"),
        });
      });
      let settings = {
        fileName:
          "FREECODE-" +
          localStorage.getItem("site-redeem").toUpperCase() +
          "-" +
          result?.release?.releaseCode,
      };
      xlsx(data, settings);
      console.log(result.status_code);
      if (result.status_code === 403) {
        alert(
          "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại để tiếp tục sử dụng."
        );
        localStorage.clear();
        window.location.replace("/login");
      } else {
        if (result.valid === true) {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });

          Toast.fire({
            icon: "success",
            title: "Thêm thành công " + result.codCount + " mã khuyến mãi",
          });
        } else {
          Swal.fire(
            "Thất bại!",
            "Có lỗi trong quá trình tạo code, vui lòng thử lại",
            "error"
          );
        }
      }
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire(
        "Thất bại!",
        "Có lỗi trong quá trình tạo code, vui lòng thử lại",
        "error"
      );
    });
};

export const deleteCode = async (
  endOf_time,
  status_code,
  promo_code,
  releaseCode,
  promo_id,
  user_used,
  ip
) => {
  if (promo_code !== "") {
    promo_code = "&promo_code=" + promo_code;
  }
  if (releaseCode !== "") {
    releaseCode = "&releaseCode=" + releaseCode;
  }
  if (promo_id !== "") {
    promo_id = "&promo_id=" + promo_id;
  }
  if (user_used !== "") {
    user_used = "&user_used=" + user_used;
  }
  if (ip !== "") {
    ip = "&ip=" + ip;
  }
  if (endOf_time !== 0) {
    endOf_time = "&endOf_time=" + endOf_time;
  }
  function bouncer(arr) {
    return arr.filter(Boolean);
  }

  let newArray = bouncer([
    promo_code,
    releaseCode,
    promo_id,
    user_used,
    ip,
    endOf_time,
  ]);

  function removeItemAll(arr, value) {
    let i = 0;
    while (i < arr.length) {
      if (arr[i] === value) {
        arr.splice(i, 1);
      } else {
        ++i;
      }
    }
    return arr;
  }

  let findCodeArray = removeItemAll(newArray, "default");

  let endPoint_check =
    localStorage.getItem("endpoint-redeem") +
    "/code/pre-delete?site=" +
    localStorage.getItem("site-redeem") +
    "&status_code=" +
    status_code;
  let endPoint_delete =
    localStorage.getItem("endpoint-redeem") +
    "/code?site=" +
    localStorage.getItem("site-redeem") +
    "&status_code=" +
    status_code;
  findCodeArray.forEach((el) => {
    endPoint_check = endPoint_check + el;
    endPoint_delete = endPoint_delete + el;
  });

  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  //
  let requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow",
  };
  await fetch(endPoint_check, requestOptions)
    .then((response) => response.json())
    .then(async (result) => {
      console.log(result);
      if (result?.total > 0) {
        await Swal.fire({
          icon: "question",
          title: `Bạn muốn xóa ${result?.total} code`,
        }).then(async (event) => {
          if (event.isConfirmed) {
            Swal.fire({
              title: "Bạn chắc chắn muốn xóa",
              text: `${result?.total} code theo kết quả tìm kiếm`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Xóa",
              cancelButtonText: "Hủy",
            }).then(async (result) => {
              if (result.isConfirmed) {
                Swal.fire({
                  text: "Đang xóa code",
                  width: 250,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                });
                await fetch(endPoint_delete, requestOptions)
                  .then((response) => response.json())
                  .then(async (result) => {
                    console.log(result);
                    if (result?.count > 0) {
                      Swal.fire({
                        title: `Xóa thành công ${result.count} code`,
                        icon: "success",
                      });
                    } else {
                      Swal.fire({
                        title: `Lỗi xóa code`,
                        icon: "error",
                      });
                    }
                  });
              }
            });
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: `Không tìm thấy code để xóa`,
        });
      }
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire("Lỗi!", "Mất kết nối đến máy chủ", "warning");
    });
};

export const get_info_promo_code = async () => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(
    localStorage.getItem("endpoint-redeem") +
      "/code/get-info?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result.result;
    })
    .catch((error) => {
      console.log("error", error);
      return 500;
    });
};

const fetchWithTimeout = (url, options, timeout = 360000) => {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), timeout)
    ),
  ]);
};

export const uploadCode = (data) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));

  const raw = JSON.stringify(data);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    mode: "cors",
  };

  fetchWithTimeout(
    localStorage.getItem("endpoint-redeem") + "/code",
    requestOptions,
    360000
  )
    .then((response) => {
      // Kiểm tra kiểu dữ liệu từ header Content-Type
      const contentType = response.headers.get("Content-Type");

      if (
        contentType.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        // Nếu là file Excel, trả về dưới dạng blob
        return response.blob();
      } else {
        // Nếu là dữ liệu JSON, trả về dưới dạng JSON
        return response.json();
      }
    })
    .then((result) => {
      // Kiểm tra kiểu dữ liệu kết quả
      if (result instanceof Blob) {
        // Xử lý blob và tải về file
        const url = window.URL.createObjectURL(result);
        const a = document.createElement("a");
        a.href = url;
        a.download = "uploaded_promo_codes.xlsx"; // Tên file tải về
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url); // Giải phóng URL sau khi tải xong
      } else {
        // Xử lý dữ liệu JSON
        if (result.code === 9009) {
          return Swal.fire({
            icon: "error",
            title: "Lỗi trùng code",
            html: `<p>${result.dupp.join(", ")}</p><p>đang bị trùng</p>`,
          });
        } else {
          return Swal.fire({
            icon: "success",
            title: "Upload data thành công",
          }).then(() => {
            window.location.reload();
          });
        }
      }
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire("Lỗi!", "Mất kết nối đến máy chủ", "warning");
    });
};

// export const uploadCode = (data) => {
//   let myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");
//   myHeaders.append("Authorization", localStorage.getItem("token-redeem"));

//   let raw = JSON.stringify(data);

//   let requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw,
//     redirect: "follow",
//     mode: "no-cors",
//   };

//   fetch(localStorage.getItem("endpoint-redeem") + "/code", requestOptions)
//     .then((response) => response.json())
//     .then((result) => {
//       if (result.code !== 502) {
//         console.log(result);
//         if (result.code === 9009) {
//           return Swal.fire({
//             icon: "error",
//             title: "Lỗi trùng code",
//             html: `<p> ${result.dupp.join(", ")}</p><p>đang bị trùng </p>`,
//           });
//         } else
//           return Swal.fire({
//             icon: "success",
//             title: "Upload data thành công",
//           }).then(() => {
//             window.location.reload();
//           });
//       } else {
//         return Swal.fire("Lỗi!", "Lỗi upload code", "warning");
//       }
//     })
//     .catch((error) => {
//       console.log("error", error);
//       Swal.fire("Lỗi!", "Mất kết nối đến máy chủ", "warning");
//     });
// };

export const changePass = (username, password) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify({
    username: username,
    password: password,
  });

  let requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(
    localStorage.getItem("endpoint-redeem") +
      "/change-pass?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      if (result.status_code === 404) {
        Swal.fire({
          icon: "error",
          title: result.mess,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Đổi mật khẩu thành công !",
        }).then(() => {
          window.location.reload();
        });
      }
    })
    .catch((error) => {
      console.log("error", error);
      Swal.fire("Lỗi!", "Mất kết nối đến máy chủ", "warning");
    });
};

export const service_getSetting = async () => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(
    localStorage.getItem("endpoint-redeem") +
      "/setting/get-setting?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      return 500;
    });
};

export const service_updateSetting = async (data) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(data);
  console.log(data);

  let requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(
    localStorage.getItem("endpoint-redeem") +
      "/setting/update-setting?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const generateCode_download = async (data) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", localStorage.getItem("token-redeem"));
  myHeaders.append("Content-Type", "application/json");

  data.createdBy = localStorage.getItem("username-redeem");
  const raw = JSON.stringify({
    ...data,
    site: localStorage.getItem("site-redeem"),
  });
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: raw,
  };
  await fetch(
    localStorage.getItem("endpoint-redeem") +
      "/generate-code-download?site=" +
      localStorage.getItem("site-redeem"),
    requestOptions
  )
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      const blob = await response.blob();
      // Tạo một đường link ẩn để tải file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `FreeCode-${localStorage
        .getItem("site-redeem")
        .toUpperCase()}_${data.releaseCode}.xlsx`;
      // Thêm đường link vào trang và kích hoạt sự kiện click
      document.body.appendChild(link);
      link.click();
      // Xóa đường link sau khi tải xong
      document.body.removeChild(link);
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });

      Toast.fire({
        icon: "success",
        title: "Thêm thành công",
      });
    })
    .catch((e) => {
      console.log(e.message);
      if (parseInt(e?.message) === 400) {
        return Swal.fire({
          title: "Random CODE trùng",
          icon: "error",
          html: "<p></p> <p>-> Thêm `Độ dài code`</p><p>-> `Xóa code` cũ</p>",
        });
      } else {
        Swal.fire(
          "Thất bại!",
          "Có lỗi trong quá trình tạo code, vui lòng thử lại",
          "error"
        );
      }
    });
};
